import { render, staticRenderFns } from "./Scrap.vue?vue&type=template&id=427fd208&"
import script from "./Scrap.vue?vue&type=script&lang=js&"
export * from "./Scrap.vue?vue&type=script&lang=js&"
import style0 from "./Scrap.vue?vue&type=style&index=0&id=427fd208&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports